import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABMegamenu extends ABBaseComponent {
  connectedCallback() {
    this.hoverTimeouts = new Map();

    // Use event delegation for clicks — handles buttons added by Liquid conditionals
    this.addEventListener('click', (e) => {
      // Close button inside megamenu panel
      const closeBtn = e.target.closest('[data-megamenu-close]');
      if (closeBtn) {
        this.closeAll();
        return;
      }
      const btn = e.target.closest('.ab-nav__disclosure-btn');
      if (btn) this.togglePanel(btn);
    });
    this.addEventListener('keydown', (e) => {
      const btn = e.target.closest('.ab-nav__disclosure-btn');
      if (btn) this.handleKeydown(e, btn);
    });

    // Hover enhancement — attach to all current nav items
    this._attachHoverListeners();

    // Close all panels when focus leaves the nav region
    this.addEventListener('focusout', (e) => {
      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) {
          this.closeAll();
        }
      });
    });

    // Escape key closes open panel
    this._onEscapeKey = (e) => {
      if (e.key === 'Escape') {
        const openBtn = this.$('.ab-nav__disclosure-btn[aria-expanded="true"]');
        if (openBtn) {
          this.closePanel(openBtn);
          openBtn.focus();
        }
      }
    };
    document.addEventListener('keydown', this._onEscapeKey);
  }

  togglePanel(btn) {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    this.closeAll();
    if (!isOpen) {
      this.openPanel(btn);
    }
  }

  openPanel(btn) {
    this.closeAll();
    const panelId = btn.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (panel) {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  }

  closePanel(btn) {
    const panelId = btn.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (panel) {
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
  }

  closeAll() {
    this.querySelectorAll('.ab-nav__disclosure-btn').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.ab-megamenu__panel').forEach((panel) => {
      panel.hidden = true;
    });
  }

  _attachHoverListeners() {
    this.querySelectorAll('.ab-nav__item').forEach((item) => {
      const btn = item.querySelector('.ab-nav__disclosure-btn');
      if (!btn) return;
      item.addEventListener('mouseenter', () => {
        clearTimeout(this.hoverTimeouts.get(btn));
        this.openPanel(btn);
      });
      item.addEventListener('mouseleave', () => {
        this.hoverTimeouts.set(
          btn,
          setTimeout(() => {
            this.closePanel(btn);
          }, 200)
        );
      });
    });
  }

  handleKeydown(e, btn) {
    // Arrow keys for horizontal navigation between top-level items
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const allItems = Array.from(this.$$('.ab-nav__item'))
        .map((item) => item.querySelector('.ab-nav__disclosure-btn, .ab-nav__link'))
        .filter(Boolean);
      const idx = allItems.indexOf(btn) !== -1 ? allItems.indexOf(btn) : allItems.indexOf(document.activeElement);
      const nextIdx =
        e.key === 'ArrowRight' ? (idx + 1) % allItems.length : (idx - 1 + allItems.length) % allItems.length;
      allItems[nextIdx]?.focus();
    }
  }

  disconnectedCallback() {
    this.hoverTimeouts?.forEach((timeout) => clearTimeout(timeout));
    if (this._onEscapeKey) {
      document.removeEventListener('keydown', this._onEscapeKey);
    }
  }
}

defineComponent('ab-megamenu', ABMegamenu);
